import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';

export const BriefBoxSkeleton = () => (
    <Container padding="4" borderRadius="lg" borderWidth="sm">
        <Skeleton width="100%">
            <Stack height="88px" direction="column" width="100%">
                <SkeletonSquare width="100%" height="32px" />
                <SkeletonSquare width="100%" height="16px" />
                <SkeletonSquare width="50%" height="16px" />
            </Stack>
            <Stack height="88px" direction="column" hidden={{ default: true, md: false }} marginTop="4" width="100%">
                <SkeletonSquare width="100%" height="32px" />
                <SkeletonSquare width="100%" height="16px" />
                <SkeletonSquare width="50%" height="16px" />
            </Stack>
        </Skeleton>
    </Container>
);
